import { render, staticRenderFns } from "./uide-B1.vue?vue&type=template&id=155e8074"
import script from "./uide-B1.vue?vue&type=script&lang=js"
export * from "./uide-B1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports